module.exports = __webpack_public_path__ + "static/media/play.7d4e3e2c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons/play.svg
 ** module id = 380
 ** module chunks = 0
 **/